import { navItems } from "@/mocks/gossip";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-accent-950 text-background-100">
      <div className="mx-auto w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-9 h-9 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-fire-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黑料吃瓜网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              黑料吃瓜网是面向吃瓜群众的内容聚合站，提供吃瓜论坛、吃瓜群入口与实时围观现场。
              我们希望每一个围观现场都保持理性与克制，讨论基于事实，尊重每一个被讨论的人。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-accent-900 px-3 py-1 text-xs text-accent-100">理性围观</span>
              <span className="rounded-full bg-accent-900 px-3 py-1 text-xs text-accent-100">拒绝谣言</span>
              <span className="rounded-full bg-accent-900 px-3 py-1 text-xs text-accent-100">尊重隐私</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-medium text-background-50">页面分区</h3>
            <ul className="mt-4 space-y-2.5">
              {navItems.slice(0, 5).map((item) => (
                <li key={item.id}>
                  <a href={`#${item.id}`} className="text-sm text-background-200/80 transition-colors hover:text-background-50 cursor-pointer">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-medium text-background-50">社区服务</h3>
            <ul className="mt-4 space-y-2.5">
              {navItems.slice(5).map((item) => (
                <li key={item.id}>
                  <a href={`#${item.id}`} className="text-sm text-background-200/80 transition-colors hover:text-background-50 cursor-pointer">
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#tags" className="text-sm text-background-200/80 transition-colors hover:text-background-50 cursor-pointer">
                  热门标签
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-accent-900 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黑料吃瓜网 · 吃瓜群众聚集地 · 内容为社区讨论展示，请理性围观</p>
          <p>本站不提供任何形式的付费入群或付费爆料服务</p>
        </div>
      </div>
    </footer>
  );
}